import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { actions } from '../../services/actions';

export const ASSET_TAB_SUMMARY = 'SUMMARY';
export const ASSET_TAB_HISTORY = 'HISTORY';
export const ASSET_TAB_ACTIVITY = 'ACTIVITY';
export const ASSET_TAB_REMOTE_DOWNLOAD = 'REMOTE_DOWNLOAD';
export const ASSET_TAB_NOTIFICATIONS = 'NOTIFICATIONS';
export const ASSET_TAB_UNIT = 'UNIT';
export const ASSET_TAB_RANGE = 'RANGE';
export const ASSET_TAB_TOUR = 'TOUR';

export type AssetTab =
    | typeof ASSET_TAB_SUMMARY
    | typeof ASSET_TAB_HISTORY
    | typeof ASSET_TAB_ACTIVITY
    | typeof ASSET_TAB_REMOTE_DOWNLOAD
    | typeof ASSET_TAB_NOTIFICATIONS
    | typeof ASSET_TAB_UNIT
    | typeof ASSET_TAB_RANGE
    | typeof ASSET_TAB_TOUR;

export type AssetTabId = keyof typeof assetTabs;

export type SidebarState = {
    tabId: AssetTab;
};

export const assetTabs = {
    1: ASSET_TAB_SUMMARY,
    2: ASSET_TAB_HISTORY,
    3: ASSET_TAB_ACTIVITY,
    5: ASSET_TAB_REMOTE_DOWNLOAD,
    6: ASSET_TAB_NOTIFICATIONS,
    7: ASSET_TAB_UNIT,
    8: ASSET_TAB_RANGE,
    9: ASSET_TAB_TOUR,
} as const;

export const getAssetTabById = (id: number) => assetTabs[id as AssetTabId] ?? ASSET_TAB_SUMMARY;
export const getAssetTabId = (type: string, set: Record<number, string> = assetTabs) =>
    Object.keys(set).find(key => set[Number(key)] === type);

export const defaultSidebarState: SidebarState = {
    tabId: ASSET_TAB_SUMMARY,
};

const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: defaultSidebarState,
    reducers: {
        sidebarTabSelectionChanged: (state, action: PayloadAction<string>) => {
            state.tabId = action.payload as AssetTab;
        },
        assetSelectedFromClusterSidebar: (_state, _action: PayloadAction<string>) => {},
    },
    extraReducers: builder => {
        builder.addCase(actions.activeAssetChanged, (state, action) => {
            if (!action.payload) {
                state.tabId = ASSET_TAB_SUMMARY;
            }
        });
    },
});

export const sidebarActions = sidebarSlice.actions;
export default sidebarSlice.reducer;
